const steps = [
  {
    icon: "ri-search-eye-line",
    title: "浏览或搜索",
    desc: "在热门资源里按分类、关键词或获取方式浏览，快速定位你想要的资源。",
  },
  {
    icon: "ri-settings-3-line",
    title: "选定格式",
    desc: "确认资源可用的网盘 / 直链 / 磁力 / 秒传，选择最顺手的方式。",
  },
  {
    icon: "ri-download-cloud-2-line",
    title: "获取并下载",
    desc: "转存、直链或挂载磁力即可下载；热门资源可直接使用打包下载入口。",
  },
  {
    icon: "ri-refresh-line",
    title: "追更补档",
    desc: "收藏关注的资源，最新更新与补档第一时间同步，不再错过失效链接。",
  },
];

export default function Guide() {
  return (
    <section id="guide" className="scroll-mt-20 bg-accent-900 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="mb-10 text-center">
          <span className="text-sm font-medium text-accent-300">使用指南</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-background-50 md:text-3xl">四步上手，轻松获取</h2>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-background-50/80">
            从浏览到补档，整个流程都为你理顺，即便是新手也能快速找到可用资源。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((s, i) => (
            <div key={s.title} className="relative rounded-lg bg-background-50/10 p-5 ring-1 ring-background-50/15 backdrop-blur">
              <span className="font-heading absolute right-4 top-4 text-3xl font-black text-background-50/25">
                0{i + 1}
              </span>
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className={`${s.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 text-base font-semibold text-background-50">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-background-50/80">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}